import * as SectionAction from './action';
const initialState = {
    activeTab: [],
    sectionList: [],
    sectionListError: [],
    caseDetails: [],
    caseDetailsError: null,
    downloadUrl: null,
    downloadUrlFail: null,
    showPdf: null,
    showPdfError: null,
    predefinedSection: [],
    previewReportSuccess: null,
    previewReportFailure: null,
    addedPredefSections: [],
    viewCompletedReportPdf: [],
    viewDownloadedReportPdf: [],
    viewCompletedReport: false,
    closeCaseSuccess: false,
    closeCaseData: [],
    reorder: false,
    publishedReport: [],
    publishReportSuccess: false,
    uploadPredefinedModal: [],
    uploadModal: [],
    uploadModalError: [],
    uploadImageResponse:[],
    uploadImageResponse:[],
    reopenCaseStatus: false,
    reopenCaseData: [],
    deletePredefinedSectionStatus: false,
    deletedPredefinedSectionData: [],
    deletedMultipleSectionData: [],
    deleteMultipleSectionStatus: false,
    caseScorecardDetails: [],
    caseScorecardDetailsError: [],
    caseScorecardRecalculate: [],
    caseScorecardRecalculateError: [],
    caseScorecardEdit: [],
    caseScorecardEditError: [],
    addedDataSections: [],
    dataSections: [],
    deletedDataSection: [],
    correspondentList: [],
    assigned: [],
    taskStatus: [],
    fetchComments: [],
    postComments: [],
    withdrawCaseSuccess: [],
    withdrawCaseFailure: [],
    downloadXbrlFile: [],
    downloadXbrlFileFailure: [],
    uploadXbrlFile: [],
    uploadXbrlFileFailure: [],
    xbrlDetails: [],
    xbrlDetailsFailure: [],
    rerunProcessing: [],
    rerunProcessingFailure: [],
    epfData:[],
    epfError: null,
    caseExecutiveSummaryDetails: [],
    ferreroKpiDetails:[],
    caseExecutiveSummaryDetailsError: [],
    bsaEntityTypes: [],
    bsaEntityTypesError: null,
    bsaBankNames: [],
    bsaBankNamesError: null,
    bsaAccountTypes: [],
    bsaAccountTypesError: null,
    allComputedSections:null,
    allComputedSectionsError:null,
    caseScorecardRationalDetails: [],
    caseScorecardRationalDetailsError: [],
    kybDetails:[],
    kybDetailsError:[],
    kybRecordSubmit:[],
    kybRecordSubmitError:[],
    scoreBreakUpDetails: [],
    scoreBreakUpDetailsError: [],
    downloadAttachment: [],
    downloadAttachmentError: [],
    scoreSummaryDetails: [],
    scoreSummaryDetailsError: []
}
const sectionReducer = (state = initialState, action) => {
    switch (action.type) {
        case SectionAction.CASE_DETAILS_SUCCESS:
            return state = {
                ...state,
                caseDetails: action.data
            }
        case SectionAction.CASE_DETAILS_FAILURE:
            return state = {
                ...state,
                caseDetailsError: action.data
            }
        case SectionAction.GET_SECTION_SUCCESS:
            // let active = activeTab(action.data)
            return state = {
                ...state,
                sectionList: action.data,
                // activeTab: [active]
            }
        case SectionAction.GET_SECTION_FAILURE:
            return state = {
                ...state,
                sectionListError: action.data
            }
        case SectionAction.REORDER_SECTIONS_SUCCESS:
            return state = {
                ...state,
                sectionList: action.data,
                reorder: true
            }
        case SectionAction.REORDER_SECTIONS_FAILURE:
            return state = {
                ...state,
                sectionListError: action,
                reorder: false
            }
        case SectionAction.CHANGE_REORDER_STATUS:
            return state = {
                ...state,
                reorder: false
            }
        case SectionAction.DOWNLOAD_SECTION_DETAILS_SUCCESS:
            return state = {
                ...state,
                downloadUrl: action.data
            }
        case SectionAction.DOWNLOAD_SECTION_DETAILS_FAILURE:
            return state = {
                ...state,
                downloadUrlFail: action.data
            }
        case SectionAction.DOWNLOAD_SUBMITTED_TASK_SUCCESS:
            return state = {
                ...state,
                downloadUrl: action.data
            }
        case SectionAction.DOWNLOAD_SUBMITTED_TASK_FAILURE:
            return state = {
                ...state,
                downloadUrlFail: action.data
            }
        case SectionAction.DOWNLOAD_PREDEFINED_SECTION_SUCCESS:
            return state = {
                ...state,
                downloadUrl: action.data
            }
        case SectionAction.DOWNLOAD_PREDEFINED_SECTION_FAILURE:
            return state = {
                ...state,
                downloadUrlFail: action.data
            }
        case SectionAction.SHOW_SECTION_PDF_SUCCESS:
            return state = {
                ...state,
                showPdf: action.data
            }
        case SectionAction.SHOW_SECTION_PDF_FAILURE:
            return state = {
                ...state,
                showPdfError: action.data
            }
        case SectionAction.PREDEFINED_SECTIONS_FAILURE:
            return state = {
                ...state,
                predefinedSection: action
            }
        case SectionAction.PREDEFINED_SECTIONS_SUCCESS:
            return state = {
                ...state,
                predefinedSection: action.data
            }
        case SectionAction.UPLOAD_SECTION_DETAILS_SUCCESS:
            return state = {
                ...state,
                uploadModal: action.data
            }
        case SectionAction.UPLOAD_SECTION_DETAILS_FAILURE:
            return state = {
                ...state,
                uploadModalError: action.data
            }
        case SectionAction.UPLOAD_IMAGES_RESPONSE:
            return state = {
                ...state,
                uploadImageResponse: action.data
            }
        case SectionAction.UPLOAD_IMAGES_RESPONSE_ERROR:
            return state = {
                ...state,
                uploadImageResponseError: action.data
            }    
        case SectionAction.UPLOAD_PREDEFINED_SECTION_SUCCESS:
            return state = {
                ...state,
                uploadPredefinedModal: action.data
            }
        case SectionAction.UPLOAD_PREDEFINED_SECTION_FAILURE:
            return state = {
                ...state,
                uploadPredefinedModal: action
            }
        case SectionAction.ADD_PREDEFINED_SECTIONS_SUCCESS:
            return state = {
                ...state,
                addedPredefSections: action.data
            }
        case SectionAction.ADD_PREDEFINED_SECTIONS_FAILURE:
            return state = {
                ...state,
                addedPredefSections: action
            }
        case SectionAction.PUBLISH_FINAL_REPORT_SUCCESS:
            return state = {
                ...state,
                publishedReport: action.data,
                publishReportSuccess: true
            }
        case SectionAction.PUBLISH_FINAL_REPORT_FAILURE:
            return state = {
                ...state,
                publishedReport: action,
                publishReportSuccess: false
            }
        case SectionAction.PREVIEW_REPORT_SUCCESS:
            return state = {
                ...state,
                previewReportSuccess: action.data
            }
        case SectionAction.PREVIEW_REPORT_FAILURE:
            return state = {
                ...state,
                previewReportFailure: action.error
            }
        case SectionAction.VIEW_PUBLISHED_REPORT_SUCCESS:
            return state = {
                ...state,
                viewCompletedReportPdf: action.data,
                viewCompletedReport: true,
            }
        case SectionAction.VIEW_PUBLISHED_REPORT_FAILURE:
            return state = {
                ...state,
                viewCompletedReportPdf: action,
                viewCompletedReport: false
            }
            case SectionAction.VIEW_DOWNLOADED_REPORT_SUCCESS:
            return state = {
                ...state,
                viewDownloadedReportPdf: action.data,
                viewDownloadedReport: true,
            }
        case SectionAction.VIEW_DOWNLOADED_REPORT_FAILURE:
            return state = {
                ...state,
                viewDownloadedReportPdf: action,
                viewDownloadedReport: false
            }
        case SectionAction.CLOSE_CASE_SUCCESS:
            return state = {
                ...state,
                closeCaseSuccess: true,
                closeCaseData: action
            }
        case SectionAction.CLOSE_CASE_FAILURE:
            return state = {
                ...state,
                closeCaseSuccess: false,
                closeCaseData: action
            }
        case SectionAction.REOPEN_CASE_SUCCESS:
            return state = {
                ...state,
                reopenCaseStatus: true,
                reopenCaseData: action
            }
        case SectionAction.REOPEN_CASE_FAILURE:
            return state = {
                ...state,
                reopenCaseStatus: false,
                reopenCaseData: action
            }
        case SectionAction.DELETE_PREDEFINED_SECTIONS_SUCCESS:
            return state = {
                ...state,
                deletePredefinedSectionStatus: true,
                deletedPredefinedSectionData: action
            }
        case SectionAction.DELETE_PREDEFINED_SECTIONS_FAILURE:
            return state = {
                ...state,
                deletePredefinedSectionStatus: false,
                deletedPredefinedSectionData: action
            }
            case SectionAction.DELETE_MULTIPLE_SECTIONS_SUCCESS:
                return state = {
                    ...state,
                    deleteMultipleSectionStatus: true,
                    deletedMultipleSectionData: action
                }
            case SectionAction.DELETE_MULTIPLE_SECTIONS_FAILURE:
                return state = {
                    ...state,
                    deleteMultipleSectionStatus: false,
                    deletedMultipleSectionData: action
                }

        case SectionAction.FETCH_CASE_SCORECARD_DETAILS_SUCCESS:
            return state = {
                ...state,
                caseScorecardDetails: action.data
            }
        case SectionAction.FETCH_CASE_SCORECARD_DETAILS_FAILURE:
            return state = {
                ...state,
                caseScorecardDetailsError: action.data
            }
        case SectionAction.RECALCULATE_SCORE_SUCCESS:
            return state = {
                ...state,
                caseScorecardRecalculate: action.data
            }
        case SectionAction.RECALCULATE_SCORE_FAILURE:
            return state = {
                ...state,
                caseScorecardRecalculateError: action.data
            }
        case SectionAction.SAVE_CASE_SCORECARD_EDIT_SUCCESS:
            return state = {
                ...state,
                caseScorecardEdit: action.data
            }
        case SectionAction.SAVE_CASE_SCORECARD_EDIT_FAILURE:
            return state = {
                ...state,
                caseScorecardEditError: action.data
            }
        case SectionAction.SET_ACTIVE_TAB:
            return state = {
                ...state,
                activeTab: action.data//addedDataSections
            }
        case SectionAction.ADD_DATA_SECTIONS_SUCCESS:
            return state = {
                ...state,
                addedDataSections: action.data,
                sectionList: action.data
            }
        case SectionAction.ADD_DATA_SECTIONS_FAILURE:
            return state = {
                ...state,
                addedDataSections: action
            }
        case SectionAction.GET_DATA_SECTIONS_SUCCESS:
            return state = {
                ...state,
                dataSections: action.data,

            }
        case SectionAction.DELETE_DATA_SECTIONS_SUCCESS:
            return state = {
                ...state,
                deletedDataSection: action.data,
                sectionList: action.data,
                activeTab: []

            }
        case SectionAction.DELETE_DATA_SECTIONS_FAILURE:
            return state = {
                ...state,
                deletedDataSection: action
            }
        case SectionAction.GET_CORRESPONDENT_LIST_SUCCESS:
            return state = {
                ...state,
                correspondentList: action.data
            }
        case SectionAction.GET_CORRESPONDENT_LIST_FAILURE:
            return state = {
                ...state,
                correspondentList: []
            }
        case SectionAction.ASSIGN_TO_CORRESPONDENT_SUCCESS:
            return state = {
                ...state,
                assigned: action.data
            }
        case SectionAction.ASSIGN_TO_CORRESPONDENT_FAILURE:
            return state = {
                ...state,
                assigned: action
            }
        case SectionAction.APPROVE_SECTION_SUCCESS:
            return state = {
                ...state,
                taskStatus: action.data
            }
        case SectionAction.APPROVE_SECTION_FAILURE:
            return state = {
                ...state,
                taskStatus: action
            }
        case SectionAction.REJECT_SECTION_SUCCESS:
            return state = {
                ...state,
                taskStatus: action.data
            }
        case SectionAction.REJECT_SECTION_FAILURE:
            return state = {
                ...state,
                taskStatus: action
            }
        case SectionAction.WITHDRAW_CASE_SUCCESS:
            return state = {
                ...state,
                withdrawCaseSuccess: action.data
            }
        case SectionAction.WITHDRAW_CASE_FAILURE:
            return state = {
                ...state,
                withdrawCaseFailure: action.data
            }
        case SectionAction.FETCH_XBRL_DETAILS_SUCCESS:
            return state = {
                ...state,
                xbrlDetails: action.data
            }
        case SectionAction.FETCH_XBRL_DETAILS_FAILURE:
            return state = {
                ...state,
                xbrlDetailsFailure: action.data
            }
        case SectionAction.DOWNLOAD_XBRL_FILE_SUCCESS:
            return state = {
                ...state,
                downloadXbrlFile: action.data
            }
        case SectionAction.DOWNLOAD_XBRL_FILE_FAILURE:
            return state = {
                ...state,
                downloadXbrlFileFailure: action.data
            }
        case SectionAction.UPLOAD_XBRL_FILE_SUCCESS:
            return state = {
                ...state,
                uploadXbrlFile: action.data
            }
        case SectionAction.UPLOAD_XBRL_FILE_FAILURE:
            return state = {
                ...state,
                uploadXbrlFileFailure: action.data
            }
        case SectionAction.RERUN_PROCESSING_SUCCESS:
            return state = {
                ...state,
                rerunProcessing: action.data
            }
        case SectionAction.RERUN_PROCESSING_FAILURE:
            return state = {
                ...state,
                rerunProcessingFailure: action.data
            }
        case SectionAction.CASE_DETAILS_EPF_SUCCESS:
            return state = {
                ...state,
                epfData: action.data
            }
        case SectionAction.CASE_DETAILS_EPF_FAILURE:
            return state = {
                ...state,
                epfError: action.data
            }
        case SectionAction.FETCH_CASE_EXECUTIVE_SUMMARY_DETAILS_SUCCESS:
            return state = {
                ...state,
                caseExecutiveSummaryDetails: action.data
            }
        case SectionAction.FETCH_CASE_EXECUTIVE_SUMMARY_DETAILS_FAILURE:
            return state = {
                ...state,
                caseExecutiveSummaryDetailsError: action.data
            }
        case SectionAction.FETCH_FERERO_KPI_DETAILS_SUCCESS:
            return state = {
                ...state,
                ferreroKpiDetails: action.data
            }
        case SectionAction.FETCH_FERERO_KPI_DETAILS_FAILURE:
            return state = {
                ...state,
                ferreroKpiDetails: action.data
            }    
        case SectionAction.BSA_ENTITY_TYPES_SUCCESS:
            return state = {
                ...state,
                bsaEntityTypes: action.data
            }
        case SectionAction.BSA_ENTITY_TYPES_FAILURE:
            return state = {
                ...state,
                bsaEntityTypesError: action.data
            }
        case SectionAction.BSA_BANK_NAMES_SUCCESS:
            return state = {
                ...state,
                bsaBankNames: action.data
            }
        case SectionAction.BSA_BANK_NAMES_FAILURE:
            return state = {
                ...state,
                bsaBankNamesError: action.data
            }
        case SectionAction.BSA_ACCOUNT_TYPES_SUCCESS:
            return state = {
                ...state,
                bsaAccountTypes: action.data
            }
        case SectionAction.BSA_ACCOUNT_TYPES_FAILURE:
            return state = {
                ...state,
                bsaAccountTypesError: action.data
            }

        case SectionAction.GET_ALL_COMPUTED_SECTION_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                allComputedSections: action.data
            }
        case SectionAction.GET_ALL_COMPUTED_SECTION_TEMPLATE_FAILURE:
            return state = {
                ...state,
                allComputedSectionsError: action.data
            }
    
        case SectionAction.FETCH_CASE_SCORECARD_RATIONAL_DETAILS_SUCCESS:
            return state = {
                ...state,
                caseScorecardRationalDetails: action.data
            }
        case SectionAction.FETCH_CASE_SCORECARD_RATIONAL_DETAILS_FAILURE:
            return state = {
                ...state,
                caseScorecardRationalDetailsError: action.data
            }
        case SectionAction.FETCH_KYB_DETAILS_SUCCESS:
            return state={
                ...state,
                kybDetails:action.data.data
            }
        case SectionAction.FETCH_KYB_DETAILS_FAILURE:
            return state={
                ...state,
                kybDetailsError:action.data
                }
        case SectionAction.KYB_RECORD_SUBMIT_SUCCESS:
            return state={
                ...state,
                kybRecordSubmit:action.data
            }
        case SectionAction.KYB_RECORD_SUBMIT_FAILURE:
            return state={
                ...state,
                kybRecordSubmitError:action.error
            }
        case SectionAction.MARK_CASE_PENDING_SUCCESS:
            return state = {
                ...state,
                markCasePendingSuccess: action.data
            }
        case SectionAction.MARK_CASE_PENDING_FAILURE:
            return state = {
                ...state,
                markCasePendingFailure: action.data
        }
         case SectionAction.FETCH_SCORE_BREAK_UP_DETAILS_SUCCESS:
            return state = {
                ...state,
                scoreBreakUpDetails: action.data
            }
        case SectionAction.FETCH_SCORE_BREAK_UP_DETAILS_FAILURE:
            return state = {
                ...state,
                scoreBreakUpDetailsError: action.data
            }

         case SectionAction.DOWNLOAD_ATTACHMENT_SUCCESS:
            return state = {
                ...state,
                downloadAttachment: action.data,

            }
        case SectionAction.DOWNLOAD_ATTACHMENT_FAILURE:
            return state = {
                ...state,
                downloadAttachmentError: action.error,
            }
        case SectionAction.FETCH_SCORE_SUMMARY_DETAILS_SUCCESS:
            return state = {
                ...state,
                scoreSummaryDetails: action.data
            }
        case SectionAction.FETCH_SCORE_SUMMARY_DETAILS_FAILURE:
            return state = {
                ...state,
                scoreSummaryDetailsError: action.data
            }
        default: return state
    }
}

export default sectionReducer;
